import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-field-text',
    templateUrl: './field-text.component.html',
    styleUrls: ['./field-text.component.scss']
})
export class FieldTextComponent implements OnChanges {
    @Input() code?: string;
    @Input() label?: string;
    @Input() error?: string;
    @Input() optionalString?: string;
    @Input() type?: 'integer' | 'float' | 'email' | 'tel' | '';
    @Input() placeholder?: string = '';
    @Input() mask?: string = '';
    // @Input() maskPrefix?: string = '';
    @Input() model: string;
    @Input() disabled: boolean = false;
    @Input() caps: boolean = false;
    @Input() instant: boolean = false;
    @Input() autofocus: boolean = false;
    @Output() modelChange = new EventEmitter();
    @Output() emitFocus = new EventEmitter();
    @Output() emitBlur = new EventEmitter();
    @Output() changed = new EventEmitter();
    @Output() enter = new EventEmitter();

    localModel: any;

    constructor(private currencyPipe: CurrencyPipe) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.model || changes.type) {
            let preventEmit = true;
            if (changes.type && changes.type.previousValue) {
                preventEmit = false;
            }
            if (this.type == 'float') {
                this.localModel = this.model;
                setTimeout(() => {
                    this.formatFloat(preventEmit);
                }, 1);
            } else if (this.type == 'integer') {
                this.localModel = this.model;
                setTimeout(() => {
                    this.formatInteger(preventEmit);
                }, 1);
            } else this.localModel = this.model;
        }
    }

    changes() {
        if (this.localModel && this.caps) {
            this.localModel = this.localModel.toUpperCase();
        }
        if (this.instant) {
            setTimeout(() => {
                this.onBlur();
            }, 1);
        }
        this.changed.emit();
    }

    onBlur($event?) {
        if (this.type == 'float') {
            this.formatFloat();
        } else if (this.type == 'integer') {
            this.formatInteger();
        } else {
            this.modelChange.emit(this.localModel);
        }
        this.emitBlur.emit();
    }

    formatFloat(preventEmit?: boolean) {
        if (!this.localModel) {
            this.localModel = undefined;
            if (!preventEmit) {
                this.modelChange.emit(undefined);
            }
            return;
        }
        let numericValue = this.localModel.toString().replace(/,/g, '.');
        if (isNaN(parseFloat(numericValue))) {
            this.localModel = undefined;
            if (!preventEmit) {
                this.modelChange.emit(undefined);
            }
        } else {
            this.localModel = parseFloat(numericValue).toString().replace(/\./g, ',');
            if (!preventEmit) {
                this.modelChange.emit(parseFloat(numericValue));
            }
        }
    }

    formatInteger(preventEmit?: boolean) {
        if (!this.localModel && this.localModel !== 0) {
            this.localModel = undefined;
            if (!preventEmit) {
                this.modelChange.emit(undefined);
            }
            return;
        }
        let numericValue = parseInt(this.localModel);
        if (isNaN(numericValue)) {
            this.localModel = undefined;
            if (!preventEmit) {
                this.modelChange.emit(undefined);
            }
        } else {
            this.localModel = numericValue;
            if (!preventEmit) {
                this.modelChange.emit(numericValue);
            }
        }
    }

    getType() {
        if (this.type && (this.type == 'email' || this.type == 'tel')) {
            return this.type;
        }
        return 'text';
    }
}
